/**
 * YMM — place product tabs under photo on desktop (1025+),
 * keep under Add to cart (info column) on mobile/tablet.
 */
(function () {
  var MQ = window.matchMedia('(min-width: 1025px)');

  function placeTabs(root) {
    root = root || document;
    var sources = root.querySelectorAll('[data-ymm-tabs-source]');
    if (!sources.length) return;

    sources.forEach(function (source) {
      var section = source.closest('.t4s-main-product__content') || source.closest('[id^="shopify-section-"]') || document;
      var mediaSlot = section.querySelector('[data-ymm-tabs-slot="media"]');
      var infoSlot = section.querySelector('[data-ymm-tabs-slot="info"]');
      if (!mediaSlot || !infoSlot) return;

      if (MQ.matches) {
        if (source.parentElement !== mediaSlot) mediaSlot.appendChild(source);
      } else if (source.parentElement !== infoSlot) {
        infoSlot.appendChild(source);
      }
    });

    document.documentElement.classList.toggle('ymm-tabs-desktop-ready', MQ.matches);
  }

  function init() {
    placeTabs(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (MQ.addEventListener) MQ.addEventListener('change', init);
  else if (MQ.addListener) MQ.addListener(init);

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
